<div class="temporality-container">
  <mat-icon>access_time</mat-icon>
  <div class="temporality-items-wrapper">
    <ng-container *ngIf="widths?.hasData; else noTemporality">
      <div
        class="temporality-items temporality-past"
        [style.width.%]="widths.past"
        matTooltip="Temporality - Past"
      ></div>
      <div
        class="temporality-items temporality-present"
        [style.width.%]="widths.present"
        matTooltip="Temporality - Present"
      ></div>
      <div
        class="temporality-items temporality-future"
        [style.width.%]="widths.future"
        matTooltip="Temporality - Future"
      ></div>
      <div
        class="temporality-items temporality-na"
        [style.width.%]="widths.na"
        matTooltip="Temporality - N/A"
      ></div>
    </ng-container>
    <ng-template #noTemporality>
      <div
        class="temporality-items temporality-empty"
        matTooltip="No temporality data"
      ></div>
    </ng-template>
  </div>
</div>
